var _excluded = ["media"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { gaHelper } from '@domain-group/fe-allhomes-library';
import { AdProvider } from '@domain-group/fe-co-allhomes-ads';
import MobileBrowseSuburb from './components/page/mobile-browse-suburb';
import DesktopBrowseSuburb from './components/page/desktop-browse-suburb';
import commonPropTypes from './common-prop-types';
import getAdTargeting from './get-ad-targeting';
import allhomesBrowseSuburbWrapper from './wrapper';
import * as styles from './allhomes-browse-suburb.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesBrowseSuburb = _ref => {
  var media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var mobile = media.mobile,
    tablet = media.tablet,
    desktop = media.desktop;
  var powOnClickHandler = (listing, index) => gaHelper.interactionEvent('Browse Search', "Property of the Week - Position ".concat(index));

  // Build combined browse-locality props out of the supplied localities plus the nearby localities
  var combinedBrowseLocalityProps = {};
  if (props.localities.sections) {
    combinedBrowseLocalityProps.sections = [...props.localities.sections];
  }
  if (props.localities.regions) {
    combinedBrowseLocalityProps.regions = [...props.localities.regions];
  }
  if (props.desktopNearbyLocalities && props.desktopNearbyLocalities.sections.length > 0) {
    if (!combinedBrowseLocalityProps.sections) {
      combinedBrowseLocalityProps.sections = [];
    }
    combinedBrowseLocalityProps.sections.push(props.desktopNearbyLocalities.sections[0]);
  }
  var desktopProps = _objectSpread({}, props);
  desktopProps.localities = combinedBrowseLocalityProps;
  return ___EmotionJSX(AdProvider, {
    targeting: getAdTargeting()
  }, ___EmotionJSX("div", {
    css: styles.container
  }, (mobile || tablet) && ___EmotionJSX(MobileBrowseSuburb, _extends({}, props, {
    powOnClickHandler: powOnClickHandler
  })), desktop && ___EmotionJSX(DesktopBrowseSuburb, _extends({}, desktopProps, {
    powOnClickHandler: powOnClickHandler
  }))));
};
AllhomesBrowseSuburb.propTypes = _objectSpread(_objectSpread({}, commonPropTypes), {}, {
  media: PropTypes.shape({})
});
AllhomesBrowseSuburb.defaultProps = {
  media: {}
};
export default allhomesBrowseSuburbWrapper(AllhomesBrowseSuburb);
export { AllhomesBrowseSuburb as BaseAllhomesBrowseSuburb };